import styled, { keyframes, css } from 'styled-components';


const fadeFromLeft = keyframes`
from {
  opacity: 0;
  transform:translateX(50) ;
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;

const rotateSmoth = keyframes`
from {

  transform: rotateX(0deg) ;
}
to{
  transform: rotateX(20deg) ;
}
`;

interface IBackground {
  background?: string;
}

interface IColor {
  color?: string;
}

export const Paragraph = styled.p`

color: #333  !important;;

p,strong,label,span,table,tr,td {
  color: #333 !important;
}

${props => props.color && css`

color: ${props.color}  !important;;

p,strong,label,span,table,tr,td {
  color: ${props.color} !important;
}

`}


`;

export const Container = styled.div<IBackground>`
  min-height: 30vh;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: none;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  color: #fff;
  padding: 0px;
  width: 100%;
  padding: 50px 0px;
 // margin: 25px 0px;


  

  img, .imageHolder{
    width: 100% ;
    max-width: 50%;
  }

  .ImageSlider{
    img{
      max-width: 100% !important;
    }
  }

 
  @media (max-width: 750px) {
    flex-direction: column !important;
    padding-bottom: 50px !important;

    img, .imageHolder{
      width: 100%;
      max-width: 100%;
    }
  }

  .contentItems{
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;

    display: flex ;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 25px;

  }

  >div.content{
    width: 100%;
    max-width: 650px;
    
 
    color: rgb(0,14,64);
    padding:  0px ;
   

    p,h2, strong,a,label,div {
 
       max-width:600px;
       margin-left: auto;
       margin-right: auto;
    }

    h2{
      font-size: 18px;
      margin-bottom: 10px;
      text-align: center;
      color:#2c3d4d;
      padding: 30px 0px;
    }

    button{
      @media (max-width: 750px) {
    margin: 10px auto;
  }

    }

    @media (max-width: 750px) {
      padding: 40px ;
  }
  }

  >h2{
    font-size: 42px;
  }

  @media (max-width: 750px) {
    padding: 0px;
  }

  .sponsors {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    margin: 30px 0;
    flex-wrap: wrap;

    > div {
      width: 300px;
      max-width: 300px;
      margin: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      > h2 {
        font-size: 16px;

        color: rgb(50, 50, 50);
      }
      > img {
        width: 100%;
        margin: 20px;
      }

      > img.logoGerenciamento {
        margin-top: 50px;
        width: 70%;
      }
    }

    @media (max-width: 750px) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  > .blocoLogo {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 2;

    .logoEvento {
      width: 100%;
      max-width: 500px;
      height: auto;
      transform: translateX(-5%);
    }

    .logoEventoMini {
      width: 100px;
      margin-top: 50px;
    }
  }

  .bloco {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
    flex-wrap: wrap;

    > a {
      margin: 10px;
    }

    @media (max-width: 750px) {
      flex-direction: column;
    }

    > a {
      > button {
        width: 200px;
        padding: 20px;
        text-align: center;
        background: rgb(0, 102, 178);
        color: #fff;
        transition: background 0.5s;
        border: 0;
        border-radius: 8px;

        &:hover {
          background: rgb(0, 102, 178);
        }
      }
    }
  }

  .separator {
    width: 100%;
    max-width: 200px;
    height: 2px;
    background: rgb(0, 102, 178);
    margin: 20px 0;
  }

  .borderedBottom {
    border: 2px solid #fff;
    padding: 10px;
    color: #fff;
    background: none;
    opacity: 0.8;
    transition: opacity 0.5s;

    &:hover {
      opacity: 1;
    }
  }

  .logoEvento {
    width: 400px;
    max-width: 80%;
  }

  .palestrantes {
    max-width: 200px;
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @media (max-width: 750px) {
      margin: 20px 0;
    }

    > .palestranteDiv {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      > .palestrante {
        width: 100px;
        max-width: 100px;
        min-width: 100px;
        height: 100px;
        margin: 10px;
        border: 2px solid rgb(0, 102, 178);
        border-radius: 50%;
        overflow: hidden;
        > img {
          width: 100%;
        }
      }

      > h2 {
        font-size: 16px;
        font-weight: bold;
        color: rgb(0, 102, 178);
      }

      > p {
        font-size: 14px;

        color: rgb(0, 102, 178);
      }
    }
  }

  .paragraph {
    max-width: 500px;
    width: 100%;

    font-size: 16px;

    > strong {
      font-weight: bold;
      color: rgb(0, 102, 178);
    }
  }



.speakerWithCountry{
  width: 100% !important;
  max-width: 200px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img{
    max-height: 120px !important ;
    min-height: 120px !important ;
    margin: 0px auto;
    margin-bottom: 15px !important;
    border-radius: 7.5px;

    max-width: 100%;
    width: auto;
    
  }

  p{
    font-size: 16px !important;
    line-height: 32px !important;
    color: #2c3d4d;
    text-align: center;
    
  }

  @media (max-width: 750px) {
    max-width: 250px !important;
    display: flex ;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
}

`;

export const ContainerWhite = styled(Container)`
  min-height: 90vh;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #fff;
  color: #555;
  padding: 100px 10%;
  width: 100%;
  max-width: 100%;
  margin: auto;

  @media (max-width: 1200px) {
    padding: 30px 20px;
    flex-direction: column;
  }

  strong {
    color: rgb(0, 100, 150);
    display: block;
  }

  > .p50 {
    z-index: 1;
    width: 50%;
    min-width: 50%;
    margin: 30px 0;

    @media (max-width: 1200px) {
      width: 100%;
      min-width: 100%;
    }

    > h2 {
      font-size: 1.5em;
    }

    > p {
      text-align: justify;
    }
  }

  .p600 {
    max-width: 600px;
    min-width: auto;
    width: 100%;

    font-size: 16px;

    > strong {
      font-weight: bold;
      color: rgb(0, 102, 178);
    }
  }
`;
